import React from 'react'
import Vote from '../Components/Dao/Vote';


const vote = () => {
  return (
    <>
        <Vote />
    </>
  )
}

export default vote;